import { combineReducers } from 'redux';
import currentImage from './currentImage';
import demoImages from './demoImages';
import imageDetails from './imageDetails';
import sampleLang from './sampleLang';
import currentSection from './currentSection';
import applicationMode from './applicationMode';
import cdnStats from './cdnStats';

const rootReducer = combineReducers({
  currentImage, demoImages, imageDetails, sampleLang, currentSection, applicationMode, cdnStats
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/js/reducers/index.js
 **/